/* Uppercase mono field label per the Figma guideline. Color is --fg-3 for the drawer's dark
 * remap; size, weight and tracking are tokens so the modal's smaller label overrides them. */
export function FieldLabel({ children }: { children: string }) {
  return (
    <span
      className="uppercase"
      style={{
        fontFamily: "var(--font-mono)",
        fontSize: "var(--onb-label-size, 12px)",
        fontWeight: "var(--onb-label-weight, 500)",
        letterSpacing: "var(--onb-label-tracking, 0.3px)",
        color: "var(--fg-3)",
      }}
    >
      {children}
    </span>
  );
}
